import { useMemo, useState } from "react";
import { QuestionCard } from "./QuestionCard";

const BULK = {
  code_issue: { label: "Genera il codice per tutte", value: { value: "generate" } },
  material: { label: "Crea tutti i materiali proposti", useDefault: true },
};

export function QuestionsPanel({ data, answer, suppliers, materials, busy }) {
  const [showDone, setShowDone] = useState(false);
  const open = data.questions.filter(q => !q.answered);
  const list = showDone ? data.questions : open;
  const groups = useMemo(() => {
    const g = {};
    open.forEach(q => { if (q.group && BULK[q.group]) (g[q.group] = g[q.group] || []).push(q); });
    return g;
  }, [open]);
  const bulk = (key) => {
    const b = BULK[key];
    answer(Object.fromEntries(groups[key].map(q => [q.id, b.useDefault ? q.default : b.value])));
  };
  return (
    <div data-testid="questions-panel">
      <div className="flex flex-wrap items-center gap-3 mb-5">
        <span className="text-sm" data-testid="questions-open-count"><b>{open.length}</b> domande da risolvere su {data.questions.length}</span>
        {Object.entries(groups).filter(([, qs]) => qs.length > 1).map(([k, qs]) => (
          <button key={k} disabled={busy} onClick={() => bulk(k)} className="btn-ghost text-xs" data-testid={`bulk-${k}`}>{BULK[k].label} ({qs.length})</button>))}
        <label className="text-sm ml-auto inline-flex items-center gap-2"><input type="checkbox" checked={showDone} onChange={e => setShowDone(e.target.checked)} data-testid="questions-show-done"/> Mostra anche quelle risolte</label>
      </div>
      {list.length === 0 && <div className="text-sm opacity-70 p-8 border border-dashed text-center" data-testid="questions-none">Nessuna domanda aperta. Controlla l'anteprima e conferma l'importazione.</div>}
      <div className="space-y-3">
        {list.map(q => <QuestionCard key={`${q.id}-${JSON.stringify(q.answer)}`} q={q} busy={busy} suppliers={suppliers} materials={materials}
          onAnswer={(a) => answer({ [q.id]: a })}/>)}
      </div>
    </div>
  );
}
